import { usePLMapboxLayersStore as m } from "./index.es12.js";
import { useMemo as b } from "react";
const p = (e, a, c) => {
  const n = Object.entries(e).map(
    ([t, r]) => ({
      combinedLayerId: t,
      layerGroupId: t,
      subLayerId: void 0,
      ...r
    })
  ), s = n.map(({ layerGroupId: t, visualFilter: r, subLayerConfig: i }) => i ? Object.entries(i).map(([u, L]) => {
    const y = {
      ...L.visualFilter,
      poiCalloutBoxLogosList: r == null ? void 0 : r.poiCalloutBoxLogosList
    };
    return {
      combinedLayerId: u,
      layerGroupId: t,
      subLayerId: u,
      ...L,
      visualFilter: y
    };
  }) : []).flat();
  return [...n, ...s].map(({ combinedLayerId: t, ...r }) => ({
    ...r,
    combinedLayerId: t,
    data: a[t],
    status: c[t]
  }));
}, f = (e, a) => {
  var o, t, r, i, u, L;
  const c = ((t = (o = e.maps) == null ? void 0 : o[a]) == null ? void 0 : t.layerGroupConfig) || {}, n = ((i = (r = e.maps) == null ? void 0 : r[a]) == null ? void 0 : i.combinedLayersData) || {}, s = ((L = (u = e.maps) == null ? void 0 : u[a]) == null ? void 0 : L.combinedLayersStatus) || {};
  return p(
    c,
    n,
    s
  );
}, g = (e) => {
  const a = m(
    (s) => {
      var o, t;
      return ((t = (o = s.maps) == null ? void 0 : o[e]) == null ? void 0 : t.layerGroupConfig) || {};
    }
  ), c = m(
    (s) => {
      var o, t;
      return ((t = (o = s.maps) == null ? void 0 : o[e]) == null ? void 0 : t.combinedLayersData) || {};
    }
  ), n = m(
    (s) => {
      var o, t;
      return ((t = (o = s.maps) == null ? void 0 : o[e]) == null ? void 0 : t.combinedLayersStatus) || {};
    }
  );
  return b(() => p(
    a,
    c,
    n
  ), [a, c, n]);
};
export {
  f as getFlattenedLayerConfigArr,
  g as useFlattenedLayerConfigArr
};
//# sourceMappingURL=index.es26.js.map
